/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfCustomerFromDiscriminatorValue, serializeCreateCustomerRequest, serializeCustomer, type CreateCustomerRequest, type Customer, type ErrorResponse, type InternalErrorResponse, type PagedResultOfCustomer } from '../../models/index.js';
// @ts-ignore
import { BulkRequestBuilderRequestsMetadata, type BulkRequestBuilder } from './bulk/index.js';
// @ts-ignore
import { BusinessCardsRequestBuilderNavigationMetadata, type BusinessCardsRequestBuilder } from './businessCards/index.js';
// @ts-ignore
import { EnrichRequestBuilderRequestsMetadata, type EnrichRequestBuilder } from './enrich/index.js';
// @ts-ignore
import { type WithCustomerNumberItemRequestBuilder, WithCustomerNumberItemRequestBuilderNavigationMetadata, WithCustomerNumberItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { MatchesRequestBuilderRequestsMetadata, type MatchesRequestBuilder } from './matches/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers
 */
export interface CustomersRequestBuilder extends BaseRequestBuilder<CustomersRequestBuilder> {
    /**
     * The bulk property
     */
    get bulk(): BulkRequestBuilder;
    /**
     * The businessCards property
     */
    get businessCards(): BusinessCardsRequestBuilder;
    /**
     * The enrich property
     */
    get enrich(): EnrichRequestBuilder;
    /**
     * The matches property
     */
    get matches(): MatchesRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.customers.item collection
     * @param customerNumber Unique identifier of the item
     * @returns {WithCustomerNumberItemRequestBuilder}
     */
     byCustomerNumber(customerNumber: string) : WithCustomerNumberItemRequestBuilder;
    /**
     * List Customers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfCustomer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<CustomersRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfCustomer | undefined>;
    /**
     * Create a Customer. Leave CustomerNumber blank to have one assigned (CUST- followed by eight uppercase letters and digits); a supplied CustomerNumber that already exists is refused.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Customer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: CreateCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Customer | undefined>;
    /**
     * List Customers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CustomersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Create a Customer. Leave CustomerNumber blank to have one assigned (CUST- followed by eight uppercase letters and digits); a supplied CustomerNumber that already exists is refused.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CreateCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * List Customers
 */
export interface CustomersRequestBuilderGetQueryParameters {
    /**
     * Gets or sets the filters for the request, this is optionalAcceptable operators are: starts with, contains, notcontains, endswith, equals, notequals, gt, get, lt, lte
     */
    filters?: string[];
    /**
     * Gets or sets the page number for the request. Default value is 1.
     */
    pageNumber?: number;
    /**
     * Gets or sets the page size for the request. Default value is 25.
     */
    pageSize?: number;
    /**
     * Gets or sets the sort direction. Can be "ASC" or "DESC". Default value is "asc".
     */
    sortDirection?: string;
    /**
     * Gets or sets the field to sort on. Default value is "Name".
     */
    sortOn?: string;
}
/**
 * Uri template for the request builder.
 */
export const CustomersRequestBuilderUriTemplate = "{+baseurl}/api/customers?filters={filters}&pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomersRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCustomerNumber: {
        requestsMetadata: WithCustomerNumberItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCustomerNumberItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["customerNumber"],
    },
    bulk: {
        requestsMetadata: BulkRequestBuilderRequestsMetadata,
    },
    businessCards: {
        navigationMetadata: BusinessCardsRequestBuilderNavigationMetadata,
    },
    enrich: {
        requestsMetadata: EnrichRequestBuilderRequestsMetadata,
    },
    matches: {
        requestsMetadata: MatchesRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfCustomerFromDiscriminatorValue,
    },
    put: {
        uriTemplate: CustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCustomerRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
